import "./bootstrap";

let sending = false;

if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (function () {
        return (
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function (
                /* function FrameRequestCallback */ callback,
                /* DOMElement Element */ element
            ) {
                window.setTimeout(callback, 1000 / 60);
            }
        );
    })();
}
const validateEmail = (email) => {
    return !!email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

$(() => {
    initHandlers();
    autosize($("textarea"));
});

$(window).on("resize", () => {
    setOrientationClass();
});

$(window).on("load", () => {
    setOrientationClass();

    setTimeout(() => {
        hideLoading();
        introAnimation();
    }, 200);
});

const initHandlers = () => {
    $("#campaign-form").on("submit", campaignFormSubmitHandler);
    $(".popup_close, .popup").on("click", closePopupHandler);
};

const introAnimation = () => {
    const landscape = $("html").hasClass("landscape");

    if (!landscape) return;

    let time = 1000;
    const $slides = $("#slides-wrapper .slide");
    $slides.each((_, slide) => {
        setTimeout(() => {
            $(slide).addClass("active");
        }, time);

        time += 500;
    });

    time += 500;
    setTimeout(() => {
        $slides.removeClass("active");
    }, time);
    setTimeout(() => {
        introAnimation();
    }, time);
};

const campaignFormSubmitHandler = (e, passForm) => {
    e.preventDefault();

    if (sending) return;

    const form = typeof passForm != "undefined" ? passForm : e.currentTarget;
    const url = form.action;
    const data = {
    	'type': $.trim($(form).find('.prompt [name=type]').val()),
    	'brand': $.trim($(form).find('.prompt [name=brand]').val()),
    	'product': $.trim($(form).find('.prompt [name=product]').val()),
    	'topic': $.trim($(form).find('.prompt [name=topic]').val()),
    	'email': $.trim($(form).find('.prompt [name=email]').val()),
    	'tos_agree': $(form).find('.prompt [name=tos_agree]').is(':checked'),
    	'tos_agree_commercial': $(form).find('.prompt [name=tos_agree_commercial]').is(':checked')
    };

    if (!formValidate()) return;

    sending = true;

    $(form).find("input, textarea").attr("disabled", "disabled");

    axios
        .post(url, data)
        .then(function (response) {
            sending = false;

            if (response.data.status === "success") {
                openPopup("success");

                $(form).find('[type="submit"]').remove();
                $(form).find(".dynamic").removeAttr("contenteditable");
                sending = true; //freeze form

                if (
                    typeof _paq != "undefined" &&
                    typeof _paq.push == "function"
                ) {
                    _paq.push(["trackEvent", "Generated", data.type]);
                }
            } else {
                openPopup('error');
				$(form).find('input, textarea').removeAttr('disabled');
            }
        })
        .catch(function (error) {
            openPopup("error");
            $(form).find("input, textarea").removeAttr("disabled");

            sending = false;
        });
};

//yolo
const formValidate = (e) => {
	var _valid = true;
	
	var first_error = false;
	var names = ['brand', 'product', 'topic'];
	for(var i in names){
		var _el = $(".prompt [name="+names[i]+"]");
		var _el_is_valid = (!_el.hasClass('default') && $.trim( _el.val() ).length > 0);
		
		
		toggleInputError(_el, !_el_is_valid);
		_valid &= _el_is_valid;
		
		if(first_error === false && !_el_is_valid){
			first_error = _el;
		}
	}
	
	var _el = $(".prompt input[name=email]");
	var _el_is_valid = validateEmail($.trim(_el.val()));
	toggleInputError(_el, !_el_is_valid);
	_valid &= _el_is_valid;
	
	var _el = $(".prompt input[name=tos_agree]");
	var _el_is_valid = _el.is(':checked');
	toggleInputError(_el, !_el_is_valid);
	_valid &= _el_is_valid;
	
	if( $("body").hasClass("brandscene") ){
		var _el = $(".prompt input[name=tos_agree_commercial]");
		var _el_is_valid = _el.is(':checked');
		toggleInputError(_el, !_el_is_valid);
		_valid &= _el_is_valid;
	}else{
		toggleInputError( $(".prompt input[name=tos_agree_commercial]"), false );
	}
	
	if(first_error !== false){
		first_error.focus();
	}
	
	return _valid;
}
const toggleInputError = (el, has_error) => {
    clearTimeout(el.attr("data-animation-timeout"));

    el.toggleClass("fadingout", false);
    el.toggleClass("error", has_error);

    if (has_error) {
        let timeout_id = setTimeout(function () {
            el.toggleClass("fadingout", true);

            let final_timeout_id = setTimeout(function () {
                el.toggleClass("error", false);
                el.toggleClass("fadingout", false);
            }, 1100);
            el.attr("data-animation-timeout", final_timeout_id);
        }, 500);
        el.attr("data-animation-timeout", timeout_id);
    }
};

const openPopup = (status = "success") => {
    const $popup = $(`#popup-${status}`);

    $popup.fadeIn(300);
    $popup.scrollTop(0);
    $popup.css({
        "overflow-x": "hidden",
        "overflow-y": "auto",
    });

    $("body").addClass("overflow-hidden");
};

const closePopupHandler = (e) => {
    e.preventDefault();

    const $target = $(e.target);
    const $closeBtn = $target.closest(".popup_close");
    const $popup = $target.closest(".popup");
    const $innerWrapper = $target.closest(".popup_inner");

    if ($closeBtn.length || !$innerWrapper.length) {
        closePopup($popup);
    }
};

const closePopup = ($popup) => {
    $popup.fadeOut(300);
    $popup.css("overflow", "hidden");

    if ($(".popup:visible").length <= 1) {
        $("body").removeClass("overflow-hidden");
    }
};

const setOrientationClass = () => {
    const width = document.body.clientWidth;
    const height = document.body.clientHeight;
    const orientation = width > height ? "landscape" : "portrait";

    $("html").removeClass("landscape portrait").addClass(orientation);
};

const hideLoading = () => {
    $("#loading").fadeOut();
};

//animations
var input_containers = [];
var prevous_defaults_index = 0;
var current_defaults_index = 0;
var input_defaults_brands = {
    brand: [
        "Coca-Cola",
        "Apple",
        "Nike",
        "Samsung",
        "McDonald's",
        "Amazon",
        "Microsoft",
        "Facebook",
        "Mercedes-Benz",
    ],
    product: [
        "Potato Cola",
        "MindPods Pro",
        "Air Max Solar",
        "Samsung RedDwarf 12",
        "McToothpaste",
        "Random Delivery+",
        "Microsoft HomeOffice",
        "MetaEats",
        "OmniChair",
    ],
    topic: [
        "a soda that tastes like boiled potatoes, with zero calories",
        "headphones using brainwaves to listen to you instead of you listening to them",
        "solar powered autonomous shoes that remove the need to run altogether",
        "a new phone with a 100″ inch screen",
        "revolutionary hamburgers that both satisfy your hunger and clean your teeth",
        "affordable service, delivering a completely random product each month",
        "a program that moves mouse once in a while so it looks like you're working",
        "paying for virtual food for your VR, without actually eating it",
        "gasoline-powered chair that transforms into a motorbike",
    ],
    email: "my email address",
};
var input_defaults_ngos = {
    brand: [
        "WWF",
        "Amnesty International",
        "Greenpeace",
        "Save the Children",
        "Women Who Code",
        "Doctors Without Borders",
        "Habitat for humanity",
        "Human Rights Campaign",
        "Oceana",
    ],
    product: [
        "Saving wolves in a forest",
        "Human rights for regfugees",
        "Deforestation and climate change",
        "Education for the underprivileged",
        "Empowering women in tech",
        "Medical humanitarian aid in Syria",
        "Affordable housing for the homeless",
        "LGBTQ+ rights and equality",
        "Responsible fishing",
    ],
    topic: [
        "Fur",
        "Advocating rights of refugees and shedding light on their challenge.",
        "Rainforest conservation mitigating climate change, preserving biodiversity",
        "Highlighting the value of education, helping to break the cycle of poverty",
        "Gender gap in technology",
        "Raising funds for healthcare needs of people bearing scars of war",
        "Hardship in winter",
        "Promote workplace inclusivity and raise awareness about unequal treatment",
        "Stopping overfishing and ending harmful/illegal fishing subsidies",
    ],
    email: "my email address",
};
//set on document ready
var current_defaults_array = [];
var previous_defaults_array = [];

$(function () {
    current_defaults_array = previous_defaults_array = (isNgo() ? input_defaults_ngos : input_defaults_brands);

    input_containers = [
        {
            dom: $("#brand"),
            timer: null,
            key: "brand",
            animator: { perc: 0 },
            previous_perc: -1,
        },
        {
            dom: $("#product"),
            timer: null,
            key: "product",
            animator: { perc: 0 },
            previous_perc: -1,
        },
        {
            dom: $("#topic"),
            timer: null,
            key: "topic",
            animator: { perc: 0 },
            previous_perc: -1,
        },
        {
            dom: $("#email"),
            timer: null,
            key: "email",
            animator: { perc: 0 },
            previous_perc: -1,
        },
    ];

    $("#type").change(function () {
        var changeto = this.value;

        $( "#campaign-form input[placeholder], #campaign-form textarea[placeholder]" ).each(function (i, _e) {
            schuffleDefaultsTimer();
        });

        $("label .alt").each(function () {
            $(this).toggleClass("active", $(this).hasClass(changeto));
        });

        $("body").toggleClass("light brandscene", changeto == "brand");
    });

    $(".prompt input, .prompt textarea").on("keydown", function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();

            //var following = $(this).nextAll('.dynamic');
            var following = $(this).parent().nextAll(".withinput");
            if (following.length > 0) {
                $(following[0]).find("input, textarea").focus();
            } else {
                campaignFormSubmitHandler(e, $(this).closest("form")[0]);
            }
        }
    });

    $(".prompt .dynamic").on("keyup paste", function (e) {
        e.stopImmediatePropagation();

        $(this).toggleClass("somecontent", $(this).text().length > 3);
    });

    schuffleDefaultsTimer();
});

function cancelDefaults(el) {
    el.toggleClass("default", false);

    var _k = el.attr("name");
    for (var i = 0; i < input_containers.length; i++) {
        if (input_containers[i].key == _k) {
            $(input_containers[i].animator).stop();
        }
    }
}
function isNgo() {
    return $("#type").val() == "ngo";
}
function triggerDefaults(el) {
    el.toggleClass("default", true);

    if (el.attr("name") == "email") {
        el.attr("placeholder", current_defaults_array["email"]);
    } else {
        //default label is better
        //el.text( current_defaults_array[el.attr('name')][current_defaults_index] );
        el.attr("placeholder", current_defaults_array[el.attr("name")][0]);
    }

    el.toggleClass("somecontent", false);
}

var schuffle_speed_base = 4000;
var schuffle_speed_rand = 2000;
var schuffle_timeout = null;
function schuffleDefaultsTimer() {
    clearTimeout(schuffle_timeout);

    previous_defaults_array = current_defaults_array;
    current_defaults_array = isNgo()
        ? input_defaults_ngos
        : input_defaults_brands;

    prevous_defaults_index = current_defaults_index;
    while (current_defaults_index == prevous_defaults_index) {
        //not necessary when switching defaults_array but whatever
        current_defaults_index = Math.floor(
            Math.random() * current_defaults_array.brand.length
        );
    }

    //current_defaults_index = current_defaults_array.brand.length - 1;//testing

    for (var i = 0; i < input_containers.length; i++) {
        //if(input_containers[i].dom.hasClass('default')){ shuffleDefaults(input_containers[i]); }
        shuffleDefaults(input_containers[i]);
    }

    clearTimeout(schuffle_timeout);
    schuffle_timeout = setTimeout(
        schuffleDefaultsTimer,
        schuffle_speed_base + schuffle_speed_rand * Math.random()
    );
}

function shuffleDefaults(shuffled) {
    var input_defaults_to = current_defaults_array;
    var input_defaults_from = previous_defaults_array;

    //console.log('from :

    if (shuffled.key == "email") {
        //shuffled.dom.text(input_defaults_to['email']);
        shuffled.dom.attr("placeholder", input_defaults_to["email"]);
    } else {
        $(shuffled.animator).stop();
        shuffled.animator.perc = 0;
        $(shuffled.animator).animate(
            { perc: 1 },
            {
                step: function (real_perc) {
                    var perc = Math.floor(real_perc * 13) / 13;

                    if (shuffled.previous_perc != perc) {
                        var word = wordTransform(
                            input_defaults_from[shuffled.key][
                                prevous_defaults_index
                            ],
                            input_defaults_to[shuffled.key][
                                current_defaults_index
                            ],
                            perc
                        );
                        //shuffled.dom.text(word);
                        shuffled.dom.attr("placeholder", word);
                    }

                    shuffled.previous_perc = perc;
                },
                easing: "linear",
                duration: 1000,
            }
        );
    }
}

function wordTransform(from, to, perc) {
    var from_length = from.length;
    var to_length = to.length;
    var length_dist = to_length - from_length;

    var transitioning_length = from_length + Math.round(length_dist * perc);

    var build_word = "";
    for (var i = 0; i < transitioning_length; i++) {
        var dice = Math.random();

        var random_chraracter = String.fromCharCode(
            0 | (Math.random() * 26 + 97)
        );
        var ideal_character = "";
        if (dice < perc) {
            //fall within probability of "transition to" word
            ideal_character = i >= to.length ? random_chraracter : to[i];
        } else {
            //fall within probability of "transitioning from" word
            ideal_character = i >= from.length ? random_chraracter : from[i];
        }

        build_word += ideal_character;
    }

    return build_word;
}
